import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { initRedditPixel } from './lib/redditPixel';
import { initGoogleAds } from './lib/googleAds';

// Suppress benign ResizeObserver error that occurs with React Flow
// This error doesn't affect functionality - it's a browser limitation
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Set --vh CSS variable for mobile browsers where 100vh includes browser chrome
function setVh() {
  const vh = (window.visualViewport?.height ?? window.innerHeight) * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setVh();
window.addEventListener('resize', setVh);
window.visualViewport?.addEventListener('resize', setVh);

// Initialize PostHog analytics
posthog.init('phc_eWN5X9S7dmDbC9mkxfUWilis4RNPNYBoZOHhkkWdVvX', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: true,
  capture_pageleave: true,
});

// Initialize Reddit Ads pixel (no-op unless a pixel ID is configured)
initRedditPixel();

// Initialize the Google Ads tag (no-op unless a conversion ID is configured)
initGoogleAds();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
